import { MapPinIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const LocationPin = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <MapPinIcon size={Sizes[size]} {...rest} />;
};

LocationPin.displayName = 'LocationPin';
